
















import BreadcrumbLinkIsHome from "@/common/components/atoms/BreadcrumbLinkIsHome.vue";
import { Vue, Component } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    BreadcrumbLinkIsHome
  }
})
export default class BreadcrumbLink extends Vue {
  @Prop({ type: String, default: "" }) url!: string;
  @Prop({ type: Boolean, default: false }) lastElement!: boolean;
  @Prop({ type: String, default: "現在のページ" }) text!: string;
  @Prop({ type: String, default: "lower" }) pageType!: string;
  @Prop({ type: Number, default: 0 }) itemKey!: number;

  linkItemClassNameBase = "p-header-breadcrumb-link__item";
  componentBaseName = "breadcrumb-link";

  get tag() {
    return this.url === "" ? "span" : "a";
  }

  get currentLinkClassName() {
    return this.lastElement
      ? `${this.linkItemClassNameBase}--current-page`
      : "";
  }

  get isHome() {
    return this.pageType === "home";
  }

  get isLower() {
    return this.pageType === "lower";
  }

  get componentName() {
    return `${this.componentBaseName}-is-${this.pageType}`;
  }

  clickDisable(e: any) {
    if (this.lastElement) {
      e.preventDefault();
    }
  }
}
